<template>
  <div class="relative flex h-full flex-col items-stretch bg-[#fdfdfd]">
    <div class="mb-8 px-8 pt-12">
      <strong class="mb-4 block text-2xl font-medium">Подтвердите вход</strong>
      <div class="flex items-center gap-2 text-sm">
        Отправили сообщение на номер:
        <button
          class="flex items-center gap-1 rounded-md text-orange-400 outline-none ring-orange-200 ring-offset-2 transition-shadow focus:ring-2"
          type="button"
          @click="emit('edit-phone')"
        >
          {{ formatPhone(props.phone) }}
          <IconEditPen class="h-4 text-orange-600" />
        </button>
      </div>
    </div>
    <div class="mx-4 mb-8 h-px bg-gray"></div>

    <div class="mx-8 grow">
      <div class="flex h-full w-full flex-col items-stretch justify-between">
        <div class="flex grow flex-col items-stretch justify-between pb-6">
            <div>
                <div class="mb-5">Введите код из СМС (4 цифры):</div>
                <div>
                    <!--<PinInput
                       name="code"
                       :length="4"
                     />-->
                    <input autocapitalize="none" maxlength="4" v-model="code" autocomplete="one-time-code" type="text" name="code" inputmode="numeric" placeholder="" class="tracking-[.75em] w-full flex-1 shrink rounded-xl border-2 border-transparent p-4 text-center text-sm shadow-main outline-none transition-colors focus:border-orange-200">
                </div>
                <div class="mt-5 flex gap-2" v-if="errorMessage.length > 0">
                    <span><DangerTriangle></DangerTriangle></span>

                    {{ errorMessage }}
                </div>

                <button
                    class="mt-5 mb-5 accent-gradient-bg group rounded-xl text-white outline-none transition-all focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 w-full px-4 py-4 text-sm font-medium uppercase flex items-center justify-center leading-none"
                    :class="code.length < 4 || formSending ? 'opacity-50' : ''"
                    :disabled="code.length < 4 || formSending"
                >
                    {{formSending ? "Входим в аккаунт..." : "Войти"}}

                    <div v-if="formSending"
                         class="ms-2 inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
                         role="status">
                        <span class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"></span>
                    </div>
                </button>
            </div>


          <button
            class="mb-2 w-full rounded-xl px-4 py-4 text-sm font-bold uppercase transition-colors"
            :class="secondsLeft > 0 ? 'bg-gray text-[rgba(0,0,0,0.5)]' : 'accent-gradient-bg text-white'"
            :disabled="secondsLeft > 0"
            @click="sendOtpAgain"
          >
            {{ secondsLeft > 0 ? 'Повторно отправить можно через ' + minutesLeft : 'Повторно отправить код' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMutation } from '@tanstack/vue-query'
import * as yup from 'yup'
import { formatPhone } from '~/utils'
import DangerTriangle from '~/components/icon/DangerTriangle.vue'

const emit = defineEmits(['edit-phone'])

const props = defineProps<{
  phone: string,
  data: string,
}>()

useForm({
  validationSchema: yup.object({
    code: yup.string().length(4).required().label('Код'),
  }),
})

const code = ref('')
const errorMessage = ref("")
const formSending = ref(false)
//const code = useFieldValue<string | undefined>('code')

const fbToken = useFCMToken()

const publicAxios = usePublicAxiosInstance()
const { mutateAsync } = useMutation({
  mutationFn: async (vals: { phone: string; code: string }) => {
    formSending.value = true
    const response = await publicAxios.post<{
      token: string
      refreshToken: string
    }>('auth/verify', {
      login: vals.phone,
      code: vals.code,
      fb_token: fbToken.value,
    })

    return response.data
  },
})

const { userCredentials } = useUserCredentials()
//watch(code, (newCode) => {
watchEffect(() => {
  errorMessage.value = ""

  if (code.value?.length === 4) {
    mutateAsync({
      phone: props.phone,
      code: code.value,
    }).then((r) => {

      code.value = ''
      userCredentials.value = {
        accessToken: r.token,
        refreshToken: r.refreshToken,
        isAuthenticated: true,
      }
    },
    (e) => {
        if (e.response.data.action == 'many attempts') {
            errorMessage.value = "Слишком много попыток. Попробуйте отправить код еще раз"
        } else if (e.response.data.action == 'wrong code') {
            errorMessage.value = "Введен неверный код"
        } else {
            errorMessage.value = "Ошибка входа в аккаунт. Попробуйте войти позднее или обратитесь в поддержку"
        }
    }).finally(() => {
        formSending.value = false
    })
  }
})

const timeout = parseInt(props.data)
const secondsLeft = ref(timeout)
const minutesLeft = computed(() => {
  return `${Math.floor(secondsLeft.value / 60)}:${secondsLeft.value % 60}`
})

const { pause, resume } = useIntervalFn(
  () => {
    secondsLeft.value = Math.max(0, secondsLeft.value - 1)
  },
  1000,
  {
    immediate: true,
  }
)

watch([secondsLeft], () => {
  if (secondsLeft.value === 0) pause()
})

const { mutate: _sendOtpAgain } = useSendOtp({
  onCheckCode: () => {
    secondsLeft.value = timeout
    resume()
  },
})
const sendOtpAgain = () => {
    code.value = ""
  _sendOtpAgain({
    phone: props.phone,
  })
}
</script>
